import * as React from "react";
import { Button, Layout, Menu, Tooltip } from "antd";
import { Link, useRouteMatch, useLocation } from "react-router-dom";
import "./SideMenu.less";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import { hasAccess } from "../RolesModule/hasAccess";
import {
  MENU_ACCOUNT_ACCOUNTINFO,
  MENU_ACCOUNT_ACCOUNTINFO_WRITE,
  MENU_ACCOUNT_AGG_USAGE,
  MENU_ACCOUNT_AGG_USAGE_WRITE,
  MENU_ACCOUNT_AGREEMENT,
  MENU_ACCOUNT_AGREEMENT_WRITE,
  MENU_ACCOUNT_BILLS,
  MENU_ACCOUNT_BILLS_WRITE,
  MENU_ACCOUNT_CHARGES,
  MENU_ACCOUNT_CHARGES_WRITE,
  MENU_ACCOUNT_PAYMENTS,
  MENU_ACCOUNT_PAYMENTS_WRITE,
  MENU_ACCOUNT_SERVICES,
  MENU_ACCOUNT_SERVICES_WRITE,
  MENU_ACCOUNT_TRANSACTION,
  MENU_ACCOUNT_TRANSACTION_WRITE,
} from "../../lib/const/permissions";
import { ReactComponent as AccountInfoIcon } from "../../img/sidemenu-icons/account-info.svg";
import { ReactComponent as AccountDetailsIcon } from "../../img/sidemenu-icons/account-details-icon.svg";
import { ReactComponent as ContractsIcon } from "../../img/sidemenu-icons/contracts-icon.svg";
import { ReactComponent as InvoicesDocumentsIcon } from "../../img/sidemenu-icons/invoices-documents-icon.svg";
import { ReactComponent as PaymentsIcon } from "../../img/sidemenu-icons/payments-icon.svg";
import { ReactComponent as ProfitsIcon } from "../../img/sidemenu-icons/profits-icon.svg";
import { ReactComponent as ServicesIcon } from "../../img/sidemenu-icons/services-icon.svg";
import { ReactComponent as TrafficIcon } from "../../img/sidemenu-icons/traffic-by-client-icon.svg";
import { hasLocalAccess } from "../../lib/configs";
import { baseUrlName } from "../../lib/routes/baseUrl";

const styles = {
  layout: {
    maxWidth: "258px",
    minWidth: "258px",
    // marginRight: "10px",
    background: "#ffffff",
  },
  userName: {
    whiteSpace: "normal",
    margin: "0",
    lineHeight: 1.2,
    padding: "12px 5px 12px 10px",
    color: "#112244",
  },
  menuItemName: {
    cursor: "default",
    height: "auto",
    padding: 0,
  },
  divider: { margin: "0" },
};

export default function SideMenu(props) {
  const { accountName, isMinimized, handleClickMinimizeButton } = props;

  const { url } = useRouteMatch();
  const { pathname } = useLocation();
  const activeKey = pathname.split("/")[3];

  const serviceDetailsPath = React.useMemo(() => {
    switch (baseUrlName) {
      case "numericIds":
      default:
        return `${url}/products`;
    }
  }, [url, baseUrlName]);

  const serviceTitle = React.useMemo(() => {
    switch (baseUrlName) {
      case "numericIds":
      default:
        return "Продукты";
    }
  }, [baseUrlName]);

  const servicesKey = React.useMemo(() => {
    switch (baseUrlName) {
      case "numericIds":
      default:
        return "products";
    }
  }, [baseUrlName]);

  if (isMinimized) {
    return (
      <Layout className="sidebar sidebar_minimized">
        <Tooltip title="Развернуть меню" placement="topLeft">
          <Button
            icon={<RightOutlined />}
            onClick={() => {
              handleClickMinimizeButton(0);
            }}
          />
        </Tooltip>
        <Menu mode="inline" selectedKeys={[activeKey]}>
          {hasAccess(MENU_ACCOUNT_ACCOUNTINFO, MENU_ACCOUNT_ACCOUNTINFO_WRITE) &&
            hasLocalAccess("account.info") && (
              <Menu.Item className="item item_selected" key="info">
                <Tooltip title="Аккаунт" placement="right">
                  <Link className="item" to={`${url}/info`}>
                    <AccountInfoIcon />
                  </Link>
                </Tooltip>
              </Menu.Item>
            )}
          {hasAccess(MENU_ACCOUNT_AGREEMENT, MENU_ACCOUNT_AGREEMENT_WRITE) &&
            hasLocalAccess("account.agreements") && (
              <Menu.Item className="item" key="agreements">
                <Tooltip title="Договоры" placement="right">
                  <Link className="item" to={`${url}/agreements`}>
                    <ContractsIcon />
                  </Link>
                </Tooltip>
              </Menu.Item>
            )}
          {hasAccess(MENU_ACCOUNT_SERVICES, MENU_ACCOUNT_SERVICES_WRITE) &&
            hasLocalAccess("account.services") && (
              <Menu.Item className="item" key={servicesKey}>
                <Tooltip title={serviceTitle} placement="right">
                  <Link className="item" to={serviceDetailsPath}>
                    <ServicesIcon color="#556677" />
                  </Link>
                </Tooltip>
              </Menu.Item>
            )}
          {hasAccess(MENU_ACCOUNT_BILLS, MENU_ACCOUNT_BILLS_WRITE) &&
            hasLocalAccess("account.bills") && (
              <Menu.Item className="item" key="bills">
                <Tooltip title="Счета" placement="right">
                  <Link className="item" to={`${url}/bills`}>
                    <InvoicesDocumentsIcon />
                  </Link>
                </Tooltip>
              </Menu.Item>
            )}
          {hasAccess(MENU_ACCOUNT_PAYMENTS, MENU_ACCOUNT_PAYMENTS_WRITE) &&
            hasLocalAccess("account.payments") && (
              <Menu.Item className="item" key="payments">
                <Tooltip title="Платежи" placement="right">
                  <Link className="item" to={`${url}/payments`}>
                    <PaymentsIcon />
                  </Link>
                </Tooltip>
              </Menu.Item>
            )}
          {hasAccess(MENU_ACCOUNT_CHARGES, MENU_ACCOUNT_CHARGES_WRITE) &&
            hasLocalAccess("account.charges") && (
              <Menu.Item className="item" key="charges">
                <Tooltip title="Начисления" placement="right">
                  <Link className="item" to={`${url}/charges`}>
                    <ProfitsIcon />
                  </Link>
                </Tooltip>
              </Menu.Item>
            )}
          {hasAccess(MENU_ACCOUNT_AGG_USAGE, MENU_ACCOUNT_AGG_USAGE_WRITE) &&
            hasLocalAccess("account.accumulators") && (
              <Menu.Item className="item" key="accumulators">
                <Tooltip title="Группы трафика" placement="right">
                  <Link className="item" to={`${url}/accumulators`}>
                    <TrafficIcon />
                  </Link>
                </Tooltip>
              </Menu.Item>
            )}
          {hasAccess(MENU_ACCOUNT_TRANSACTION, MENU_ACCOUNT_TRANSACTION_WRITE) &&
            hasLocalAccess("account.detalization") && (
              <Menu.Item className="item" key="detalization">
                <Tooltip title="Детализация по аккаунту" placement="right">
                  <Link className="item" to={`${url}/detalization`}>
                    <AccountDetailsIcon />
                  </Link>
                </Tooltip>
              </Menu.Item>
            )}
        </Menu>
      </Layout>
    );
  }
  return (
    <Layout style={styles.layout} className="sidebar sidebar_expanded">
      <div className="title-header">
        <h3 style={styles.userName}>{accountName}</h3>
        <Tooltip title="Свернуть меню" placement="topLeft">
          <Button
            icon={<LeftOutlined />}
            onClick={() => {
              handleClickMinimizeButton(1);
            }}
          />
        </Tooltip>
      </div>
      <Menu mode="inline" selectedKeys={[activeKey]}>
        {hasAccess(MENU_ACCOUNT_ACCOUNTINFO, MENU_ACCOUNT_ACCOUNTINFO_WRITE) &&
          hasLocalAccess("account.info") && (
            <Menu.Item className="menu__textItem" key="info">
              <Link className="menu__textItem" to={`${url}/info`}>
                Аккаунт
              </Link>
            </Menu.Item>
          )}
        {hasAccess(MENU_ACCOUNT_AGREEMENT, MENU_ACCOUNT_AGREEMENT_WRITE) &&
          hasLocalAccess("account.agreements") && (
            <Menu.Item className="menu__textItem" key="agreements">
              <Link className="menu__textItem" to={`${url}/agreements`}>
                Договоры
              </Link>
            </Menu.Item>
          )}
        {hasAccess(MENU_ACCOUNT_SERVICES, MENU_ACCOUNT_SERVICES_WRITE) &&
          hasLocalAccess("account.services") && (
            <Menu.Item className="menu__textItem" key={servicesKey}>
              <Link className="menu__textItem" to={serviceDetailsPath}>
                {serviceTitle}
              </Link>
            </Menu.Item>
          )}
        {hasAccess(MENU_ACCOUNT_BILLS, MENU_ACCOUNT_BILLS_WRITE) &&
          hasLocalAccess("account.bills") && (
            <Menu.Item className="menu__textItem" key="bills">
              <Link className="menu__textItem" to={`${url}/bills`}>
                Счета
              </Link>
            </Menu.Item>
          )}
        {hasAccess(MENU_ACCOUNT_PAYMENTS, MENU_ACCOUNT_PAYMENTS_WRITE) &&
          hasLocalAccess("account.payments") && (
            <Menu.Item className="menu__textItem" key="payments">
              <Link className="menu__textItem" to={`${url}/payments`}>
                Платежи
              </Link>
            </Menu.Item>
          )}
        {hasAccess(MENU_ACCOUNT_CHARGES, MENU_ACCOUNT_CHARGES_WRITE) &&
          hasLocalAccess("account.charges") && (
            <Menu.Item className="menu__textItem" key="charges">
              <Link className="menu__textItem" to={`${url}/charges`}>
                Начисления
              </Link>
            </Menu.Item>
          )}
        {hasAccess(MENU_ACCOUNT_AGG_USAGE, MENU_ACCOUNT_AGG_USAGE_WRITE) &&
          hasLocalAccess("account.accumulators") && (
            <Menu.Item className="menu__textItem" key="accumulators">
              <Link className="menu__textItem" to={`${url}/accumulators`}>
                Группы трафика
              </Link>
            </Menu.Item>
          )}
        {hasAccess(MENU_ACCOUNT_TRANSACTION, MENU_ACCOUNT_TRANSACTION_WRITE) &&
          hasLocalAccess("account.detalization") && (
            <Menu.Item className="menu__textItem" key="detalization">
              <Link className="menu__textItem" to={`${url}/detalization`}>
                Детализация по аккаунту
              </Link>
            </Menu.Item>
          )}
      </Menu>
    </Layout>
  );
}
